$(document).ready(function(){
  var currentCurrency = window.theme.currentCurrency;

  /**
   * Get selling plan for the bundle.
   *
   * Priority:
   * 1. Main / bundle product selling plan
   * 2. Selected product ALL selling plan groups (fallback)
   *
   * Guard: matched plan id must be allocated to the selected variant
   * (variant.selling_plan_allocations, stored as product.selling_plans).
   * If no match / not allocated -> returns '' -> item is added as a normal
   * (one-time) purchase.
   */
  function getBundleSellingPlan(product, selectFreqVal, isSubs) {
    if (!isSubs) {
      return '';
    }

    let sellingPlanId = '';

    // Build a Set of selling plan ids allocated to THIS variant (guard source)
    const allocatedPlanIds = new Set();
    if (Array.isArray(product?.selling_plans)) {
      product.selling_plans.forEach((alloc) => {
        // Shopify allocation may expose id as 'selling_plan_id' or nested 'selling_plan.id'
        const pid = alloc?.selling_plan_id ?? alloc?.selling_plan?.id;
        if (pid != null) {
          allocatedPlanIds.add(String(pid));
        }
      });
    }

    // Lenient guard: if the variant has NO allocation data at all, allow the plan.
    // To make it strict (block subscription when allocation data missing),
    // replace the body with: return allocatedPlanIds.has(String(planId));
    const isAllocated = (planId) =>
      allocatedPlanIds.size === 0 || allocatedPlanIds.has(String(planId));

    /*
    * Main product selling plans are exposed from custom-bundle.liquid
    * through window.customBundleMainProductSellingPlans.
    */
    if (
      Array.isArray(window.customBundleMainProductSellingPlans) &&
      window.customBundleMainProductSellingPlans.length > 0
    ) {
      const mainProductPlan = window.customBundleMainProductSellingPlans.find((plan) => {
        return (
          plan.name &&
          selectFreqVal &&
          plan.name.trim() === selectFreqVal.trim()
        );
      });

      // Main product plan must also be allocated to this variant
      if (mainProductPlan && isAllocated(mainProductPlan.id)) {
        sellingPlanId = mainProductPlan.id;
      }
    }

    /*
    * Fallback:
    * If main product does not have the matching (allocated) selling plan,
    * loop over ALL selling plan groups of the selected bundle product
    * and use the first name-matched + allocated plan.
    */
    if (!sellingPlanId && product?.selling_plan_groups?.length) {
      for (let i = 0; i < product.selling_plan_groups.length; i++) {
        const group = product.selling_plan_groups[i];

        const matchedPlan = group?.selling_plans?.find((plan) => {
          return (
            plan.name &&
            selectFreqVal &&
            plan.name.trim() === selectFreqVal.trim() &&
            isAllocated(plan.id) // guard: allocated to this variant only
          );
        });

        if (matchedPlan) {
          sellingPlanId = matchedPlan.id;
          break; // stop at first match
        }
      }
    }

    // No match / not allocated -> '' -> normal (one-time) add
    return sellingPlanId;
  }

  $('.js-custom-sub-trigger').off('click').on('click',function (e) {
    var $radio = $(this).find(`input[type="radio"]`);
    $('.js-selected').removeClass('js-selected');
    $(this).addClass('js-selected');
    $('.loop-selling-plan-fieldset input').prop('checked',false);
    $('.loop-subscription-group-selling-plans-container').hide();
    if($radio.length > 0){
      var inputName = $radio.attr('data-name');
      // console.log('inputName',inputName)
      if(inputName.indexOf('Subscribe and Save') > -1){
        $('.loop-subscription-group-selling-plans-container').show();
      }
    // console.log($radio)
      $radio.prop('checked',true);
    }
  })
  if(window.theme.custom_bundle_available){

    document.querySelector('.product_bundle_details').classList.add('hide');
    // Separate Variants mode: each grid card is already bound to one fixed variant,
    // so there are no variant <select> elements to enable/disable.
    const separateVariants = $('#product-grid').attr('data-separate-variants') === 'true';

    // Product Add Counts
    const onProductCount = $(".product-amount-wrapper .amount-items.active button").data('product-count');
    if($('.product-grid-container .product-amount-heading .heading .select-total-counts')){
      $('.product-grid-container .product-amount-heading .heading .select-total-counts').text(onProductCount)
    }

    // Global Functions
    function changeProductAmountData(title_handle, title, product_count, discount, discount_text) {
      var currentSelectedCount = selectedProducts.length;
      // Change Total Counts
      if($('.select-product-counts .select-total-counts')){
        $('.select-product-counts .select-total-counts').text(product_count);        
      }
      if($('.product-grid-container .product-amount-heading .heading .change-amount')){
        $('.product-grid-container .product-amount-heading .heading .change-amount').text(product_count)
      }

      // Change Product Price as per discount
      selectedProducts.forEach((product) => {
        const originalPrice = parseFloat(product.price.replace(/[^\d.-]/g, '')); // Remove ₹ and convert to number
        const discountedPrice = originalPrice - (originalPrice * discount / 100); // Calculate discounted price
        
        // Convert to currency format
        const formattedOriginalPrice = Shopify.formatMoney(originalPrice * 100) // For Shopify currency formatting
        const formattedDiscountedPrice = Shopify.formatMoney(discountedPrice * 100)
        
        // Update object
        product.price = formattedOriginalPrice.replace('$', currentCurrency);
        product.discountedPrice = formattedDiscountedPrice.replace('$', currentCurrency);
        // Update HTML Change
        const $item = $(`.items-main[data-prod-id="${product.prodId}"][data-index="${product.index}"]`);
    
        if ($item.length) {
          // Update the regular price
          // $item.find('.regular-price').text(formattedOriginalPrice);
        
          // Update the discounted price
          var updatedPrice = `<span class="check-price regular-price custom-js-price price">${product.price}</span>${product.discountedPrice}`
          $item.find('h5.custom-js-price').empty().html(updatedPrice)
        }
      });
      
      if (product_count < currentSelectedCount) {
        const itemsToRemove = currentSelectedCount - product_count;            
        selectedProducts.splice(-itemsToRemove);        
        // $(".items-media-wrapper ul li").not(".null-item").slice(-itemsToRemove).remove();

        // Remove from UI
        $(".items-media-wrapper ul li").not(".null-item").slice(-itemsToRemove).each(function () {
            $(this).remove();
        });
        
        $(".items-details-wrapper ul li").slice(-itemsToRemove).remove();
        
        currentSelectedCount = product_count;
      }
      mainRemainingCount = currentSelectedCount;
            
      const remainingNullItems = product_count - selectedProducts.length;      
      // Clear existing null items
      $(".items-media-wrapper ul .null-item").remove();      
      let var_price = 0, actual_price = 0;
      selectedProducts.forEach(product => {
        var_price += parseFloat(product.price.replace(/[^\d.-]/g, ''));
        actual_price += parseFloat(product.discountedPrice.replace(/[^\d.-]/g, ''));
      });
      
      $('.loop-discount-price').text(currentCurrency + var_price.toFixed(2));
      $('.loop-one-time-purchase-option-price-amount').text(currentCurrency + actual_price.toFixed(2));

      //ADD Discount Price
      var first_discount = parseFloat($('.loop-selling-plan-selector').find('option:first').attr('data-discount'));
      if (!isNaN(first_discount)) {
        var first_discount_amount = parseFloat($('.loop-one-time-purchase-option-price-amount').text().replace(currentCurrency, ''));              
        var discounted_price = (first_discount_amount - (first_discount_amount * (first_discount / 100))).toFixed(2);
        $('.loop-subscription-group-price-amount').text(currentCurrency + discounted_price);
      }
      
      if (!isNaN(first_discount)) {
        let discount_rate = 0;
              selectedProducts.forEach(product => {
                discount_rate += parseFloat(product.discountedPrice.replace(/[^\d.-]/g, ''));
              });
        discount_rate = discount_rate.toFixed(2);
        $('.loop-selling-discount').text(currentCurrency + discount_rate);

        if(window.innerWidth > 1024){
          var isNoDiscount = parseFloat($('.product-single__form.desktop_only_widget .loop-selling-plan-selector').find('option:checked').attr('data-discount'))
        }else{
          var isNoDiscount = parseFloat($('.product-single__form.mobile_only_widget .loop-selling-plan-selector').find('option:checked').attr('data-discount'))
        }
        if(isNoDiscount == 0){
          $('.product-custom-bundle .info_bg .product-single__form .loop-subscription-group-discount-badge').text(`Save ${currentCurrency}0.00`)
        }else{
          var remainingPrice = discount_rate - discounted_price;
          remainingPrice = remainingPrice.toFixed(2)
          $('.product-custom-bundle .info_bg .product-single__form .loop-subscription-group-discount-badge').text(`Save ${currentCurrency + remainingPrice }`)
        }
      }
      
      for (let index = 0; index < remainingNullItems; index++) {
        $(".items-media-wrapper ul").append('<li class="null-item"><img src="" alt=""></li>');
        let totalPrice = 0, regular_price = 0;
        selectedProducts.forEach(product => {
          totalPrice += parseFloat(product.price.replace(/[^\d.-]/g, ''));
          regular_price += parseFloat(product.discountedPrice.replace(/[^\d.-]/g, ''));
        });
        
        $('.loop-discount-price').text(currentCurrency + totalPrice.toFixed(2));
        $('.loop-one-time-purchase-option-price-amount').text(currentCurrency + regular_price.toFixed(2));

        //ADD Discount Price
        var firstOptionDiscount = parseFloat($('.loop-selling-plan-selector').find('option:first').attr('data-discount'));
        if (!isNaN(firstOptionDiscount)) {
          var amount_get = parseFloat($('.loop-one-time-purchase-option-price-amount').text().replace(currentCurrency, ''));
          var discounted_Price = (amount_get - (amount_get * (firstOptionDiscount / 100))).toFixed(2);
          $('.loop-subscription-group-price-amount').text(currentCurrency + discounted_Price);
        }
        
        if (!isNaN(firstOptionDiscount)) {
          let discount_rate = 0;
          selectedProducts.forEach(product => {
            discount_rate += parseFloat(product.discountedPrice.replace(/[^\d.-]/g, ''));
          });
          discount_rate = discount_rate.toFixed(2);
          $('.loop-selling-discount').text(currentCurrency + discount_rate);

          if(window.innerWidth > 1024){
            var isNoDiscount = parseFloat($('.product-single__form.desktop_only_widget .loop-selling-plan-selector').find('option:checked').attr('data-discount'))
          }else{
            var isNoDiscount = parseFloat($('.product-single__form.mobile_only_widget .loop-selling-plan-selector').find('option:checked').attr('data-discount'))
          }
          if(isNoDiscount == 0){
            $('.product-custom-bundle .info_bg .product-single__form .loop-subscription-group-discount-badge').text(`Save ${currentCurrency}0.00`)
          }else{
            var remainingPrice = discount_rate - discounted_Price;
            remainingPrice = remainingPrice.toFixed(2)
            $('.product-custom-bundle .info_bg .product-single__form .loop-subscription-group-discount-badge').text(`Save ${currentCurrency + remainingPrice }`)
          }
        }
      }
      
      // Change Remaining Counts
      if($('.select-product-counts .select-remaining-counts')){
        $('.select-product-counts .select-remaining-counts').text(currentSelectedCount);
      }
      if($('.bundle-select-count .bundle-remaining-counts')){
        $('.bundle-select-count .bundle-remaining-counts').text(currentSelectedCount);
      }
      if($('.product-grid-container .product-amount-heading .heading p')){
        $('.product-grid-container .product-amount-heading .heading .change-amount').text(product_count)
      }
      const cartRemaining = product_count - currentSelectedCount;
      // if(currentSelectedCount == 0){
      //   $('.bundle-section-main .info_bg').hide();  
      // }
      if($('.bundle-atc-btn .cart-remaining-count')){
        $('.bundle-atc-btn .cart-remaining-count').text(cartRemaining);
      }
    
      if (product_count > currentSelectedCount) {
        const enableVariantSelector = $('.product-grid .grid__item .select__select');
        enabledElements(enableVariantSelector);

        if (separateVariants) {
          // No dropdowns in this mode, the variant is fixed per card, so every Add button is valid.
          $('.card-item-add-btn-wrapper .add-btn').removeAttr('disabled').prop('disabled', false).removeClass('disabled');
        } else {
          $('.product-grid .grid__item .select__select').each(function () {
            const $variantSelect = $(this);
            const $addButton = $variantSelect.closest('.grid__item').find('.card-item-add-btn-wrapper .add-btn');

            if ($variantSelect.val()) {
              $addButton.prop('disabled', false).removeClass('disabled');
            } else {
              $addButton.prop('disabled', true).addClass('disabled');
            }
          });
        }
      } else {
        if (separateVariants) {
          // Bundle is full: lock the Add buttons and release the Add to cart button.
          disabledElements(null, $('.card-item-add-btn-wrapper .add-btn'));
        } else {
          const variantSelector = $('.product-grid .grid__item .select__select:not(:disabled)');
          const disabledAddButton = $('.card-item-add-btn-wrapper .add-btn:not(disabled)');
          if (variantSelector.length) { // Only disable if no valid select options are available
            disabledElements(variantSelector, disabledAddButton);
          }
        }
      }

      if(currentSelectedCount == 0){
        $('.bundle-info-wrapper').removeClass('on-sticky');
        $('body').removeClass('bundle-sticky');
        if($('.shopify-section.product_bundle_details')){
          $('.shopify-section.product_bundle_details').addClass('hide');
        }
      }else{
        $('.bundle-info-wrapper:not(.on-sticky)').addClass('on-sticky');
        $('body').addClass('bundle-sticky');
      }

      // Hide Product Info Section
     $('.bundle_product_details .bundle_info_section').addClass('hide');
      selectedProducts.forEach(function(product) {
        var prodId = product.prodId;
        if ($('.bundle_product_details').length) {
          setTimeout(()=>{
            $('.bundle_product_details .bundle_info_section[data-id="' + prodId + '"]').removeClass('hide');
          },150)
        }
      });
    }

    // Disabled variant Selector & Add Buttons Function
    $('.custom-bundle-main').addClass('price_hide');
    function disabledElements(variantSelector, AddButton){
      if(variantSelector){
        variantSelector.attr('disabled', 'disabled');        
      }
      if(AddButton){
        AddButton.attr('disabled', 'disabled');        
      }
      if($('.cart-btn-main .bundle-atc-btn')){
        $('.cart-btn-main .bundle-atc-btn').removeAttr('disabled', 'disabled');
        $('.custom-bundle-main').removeClass('price_hide');
        $('.cart-btn-main .bundle-atc-btn .cart-remaining-wrapper').addClass('hide')
        $('.cart-btn-main .bundle-atc-btn .add-cart-text').removeClass('hide');
      }
    }

    // Enabled variant Selector & Add Buttons Function
    function enabledElements(variantSelector, AddButton){
      if(variantSelector){
        variantSelector.removeAttr('disabled', 'disabled');
      }
      if(AddButton){
        AddButton.removeAttr('disabled', 'disabled');
      }
      if($('.cart-btn-main .bundle-atc-btn')){
        $('.cart-btn-main .bundle-atc-btn').attr('disabled', 'disabled');
        $('.custom-bundle-main').addClass('price_hide');
        $('.cart-btn-main .bundle-atc-btn .cart-remaining-wrapper').removeClass('hide')
        $('.cart-btn-main .bundle-atc-btn .add-cart-text').addClass('hide');
      }
    }

    // BURST Animation FUCNTION    
    function startAnimation(canvas) {
      const ctx = canvas.getContext('2d');
    
      // Set canvas size
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    
      const shapes = [];
      const colors = ['#0D394E', '#E6FA72', '#e11b6c', '#9a94eb', '#a9eaff']; // Shape outline colors
      let scaleCircle = 0; // Scale for central circle    
      
      class Shape {
        constructor(x, y, size, type, color) {
          this.x = x;
          this.y = y;
          this.size = size;
          this.type = type; // circle or diamond
          this.color = color;
          this.velocityX = (Math.random() - 0.5) * 8; // Increased velocity for faster movement
          this.velocityY = (Math.random() - 0.5) * 8; // Increased velocity for faster movement
          this.alpha = 0.9; // Initial opacity
        }
      
        draw() {
          ctx.globalAlpha = this.alpha;
          ctx.strokeStyle = this.color; // Outline color
          ctx.fillStyle = this.color; // Fill color
          ctx.lineWidth = 2;
          ctx.beginPath();
      
          if (this.type === 'circle') {
            ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
            ctx.fill(); // Fill the circle
          } else if (this.type === 'diamond') {
            // Diamond with curved sides
            const curve = this.size * 0.4; // Adjust the curve radius here
            ctx.moveTo(this.x, this.y - this.size); // Top point
            ctx.quadraticCurveTo(
              this.x + curve,
              this.y - curve,
              this.x + this.size,
              this.y
            ); // Top-right curve
            ctx.quadraticCurveTo(
              this.x + curve,
              this.y + curve,
              this.x,
              this.y + this.size
            ); // Bottom-right curve
            ctx.quadraticCurveTo(
              this.x - curve,
              this.y + curve,
              this.x - this.size,
              this.y
            ); // Bottom-left curve
            ctx.quadraticCurveTo(
              this.x - curve,
              this.y - curve,
              this.x,
              this.y - this.size
            ); // Top-left curve
            ctx.closePath();
            ctx.fill(); // Fill the diamond
          }
      
          ctx.stroke(); // Draw outline
        }
      
        update() {
          this.x += this.velocityX;
          this.y += this.velocityY;
          this.alpha -= 0.03; // Faster fade-out
        }
      }

    
      // Create explosion shapes
      function createShapes(x, y) {
        for (let i = 0; i < 15; i++) {
          const type = ['circle', 'diamond'][Math.floor(Math.random() * 2)]; // Choose between circle and diamond
          const color = colors[Math.floor(Math.random() * colors.length)];
          const size = (Math.random() * 5 + 3) * 2.5; // Increase size by 50%
          shapes.push(new Shape(x, y, size, type, color));
        }
      }
    
      // Draw central scaling circle
      function drawCentralCircle() {
        ctx.beginPath();
        ctx.arc(canvas.width / 2, canvas.height / 2, scaleCircle, 0, Math.PI * 2);
        ctx.strokeStyle = '#0D394E';
        ctx.lineWidth = 5;
        ctx.stroke();
      }
    
      // Animate the canvas
      function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    
        // Scale the central circle
        if (scaleCircle < 150) {
          scaleCircle += 3; // Faster scaling
        }
    
        drawCentralCircle();
    
        // Draw and update shapes
        for (let i = 0; i < shapes.length; i++) {
          shapes[i].draw();
          shapes[i].update();
    
          // Remove shapes that are fully faded
          if (shapes[i].alpha <= 0) {
            shapes.splice(i, 1);
            i--;
          }
        }
    
        requestAnimationFrame(animate);
      }
    
      // Start both circle scaling and shape explosion simultaneously
      createShapes(canvas.width / 2, canvas.height / 2); // Explode from the center
      animate();
    }

    // startAnimation(canvas);

    
    
    
// CLICK or CHANGE Function Scripts
    $('body').on('click','.amount-items .items-button', function() {
      $('.product-amount-wrapper .amount-items').removeClass('active');
      $(this).parent().addClass('active');

      // Get Product Amount Data
      var title_handle = $(this).data('title-handle'),
      title = $(this).data('title'),
      product_count = $(this).data('product-count'),
      discount = $(this).data('discount'),
      discount_text = $(this).data('discount-text');

      if($('.bundle-items-container .bundle-amount-dropdown .amount-selector')){
        $('.bundle-items-container .bundle-amount-dropdown .amount-selector').val(title_handle);
      }
      if($('.mobile-product-amount-wrapper select')){
        $('.mobile-product-amount-wrapper select').val(title_handle);
      }

      // Call Function for get Product Amount Data
      changeProductAmountData(title_handle,title,product_count,discount,discount_text)

    })
    $('.bundle-amount-dropdown .amount-selector').on('change',function() {
      var optionVal = $(this).val();
      var selectedOption = $(this).find('option:selected')
      var title_handle = selectedOption.data('title-handle'),
      title = selectedOption.data('title'),
      product_count = selectedOption.data('product-count'),
      discount = selectedOption.data('discount'),
      discount_text = selectedOption.data('discount-text');

      var buttonElement = $('.product-amount-wrapper').find('.amount-items .items-button[data-title-handle="'+optionVal+'"]')
      if(buttonElement){
        $('.product-amount-wrapper .amount-items').removeClass('active');
        buttonElement.parent().addClass('active');        
      }

      if($('.mobile-product-amount-wrapper select')){
        $('.mobile-product-amount-wrapper select').val(title_handle);
      }

      // Call Function for get Product Amount Data
      changeProductAmountData(title_handle,title,product_count,discount,discount_text)
    });

    $('.mobile-product-amount-wrapper select').on('change',function() {
      var optionVal = $(this).val();
      var selectedOption = $(this).find('option:selected')
      var title_handle = selectedOption.data('title-handle'),
      title = selectedOption.data('title'),
      product_count = selectedOption.data('product-count'),
      discount = selectedOption.data('discount'),
      discount_text = selectedOption.data('discount-text');

      if($(this).siblings('.mobile-discount-text') && discount_text){
        $(this).siblings('.mobile-discount-text').text(discount_text)
      }
      var buttonElement = $('.product-amount-wrapper').find('.amount-items .items-button[data-title-handle="'+optionVal+'"]')
      if(buttonElement){
        $('.product-amount-wrapper .amount-items').removeClass('active');
        buttonElement.parent().addClass('active');        
      }
      if($('.bundle-items-container .bundle-amount-dropdown .amount-selector')){
        $('.bundle-items-container .bundle-amount-dropdown .amount-selector').val(title_handle);
      }

      // Call Function for get Product Amount Data
      changeProductAmountData(title_handle,title,product_count,discount,discount_text)
    });
    
    // Variant Change Events
    $(".product-grid .grid__item .select__select").on("change", function () {
      const selectedVariantId = $(this).val();    
      const parentItem = $(this).closest(".grid__item.bundle-items");    
      const variantFeatureImg = $(this).find('option:selected').data('variant-feature-img');
      // console.log("variantFeatureImg::",variantFeatureImg)
      if(variantFeatureImg){
        parentItem.find('.card__media img').attr('src',variantFeatureImg);
      }
      const addButton = parentItem.find(".card-item-add-btn-wrapper .add-btn"); 
      // addButton.prop("disabled", false);
    
      addButton.data("selected-variant-id", selectedVariantId);
    });
    
    // Add button click event listener
    var selectedProducts = [];
    var mainRemainingCount = 0
    $(".product-grid .grid__item .add-btn").on("click", function () {
      const productId = $(this).data("prod-id");
      const selectedVariantId = $(this).data("selected-variant-id");

      if(!productsData) return    
      const productsArray = Object.values(productsData);

      mainRemainingCount = mainRemainingCount + 1;

      // Selected product data find karo productsArray mathi
      const selectedProduct = productsArray.find(product => product.id === productId);
      if (selectedProduct) {    
        if($('.shopify-section.product_bundle_details').hasClass('hide')){
          $('.shopify-section.product_bundle_details').removeClass('hide');
        }
        const selectedVariant = selectedProduct.variants.find(variant => variant.id == selectedVariantId);
        const selectedVariantSellingPlans = selectedVariant.selling_plan_allocations;
    
        if (selectedVariant) {

          var parentItem = $(this).closest(".grid__item.bundle-items");

          var canvas = parentItem.find('canvas').get(0)
          // console.log("canvas",canvas)
          startAnimation(canvas);
    
          parentItem.addClass("animate-open");
          
          setTimeout(function() {
              parentItem.removeClass("animate-open");
          }, 1000);
          
          // Add the product image to the first null-item (li) and update class
          const firstFillItem = $(".bundle-items-main .null-item:first");
          var itemsIndex = selectedVariant.id + '_' + selectedProducts.length
          firstFillItem.find("img").attr("src", selectedVariant && selectedVariant.featured_image ? selectedVariant.featured_image.src : selectedProduct.featured_image);
          firstFillItem.removeClass("null-item").addClass("fill-item");
          firstFillItem.attr("data-prod-id",selectedProduct.id)
          firstFillItem.attr("data-index",itemsIndex)
          var closeHTML = `<div class="close-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="6.5" transform="rotate(-180 7 7)" fill="#FAF4DE" stroke="#0D394E"/><path d="M5 9L7 7L5 5" stroke="#0D394E" stroke-linecap="round"/><path d="M9 5L7 7L9 9" stroke="#0D394E" stroke-linecap="round"/></svg></div>`;
          firstFillItem.append(closeHTML)

          // console.log("selectedVariant::",selectedVariant)
          // Calculate Price & Discount
          const discountPercentage = parseFloat($(".product-amount-wrapper .amount-items.active button").data('discount')) || 0;          
          const discountAmount = (selectedVariant.price * discountPercentage) / 100;
          const discountedPrice = selectedVariant.price - discountAmount;
          
          var regularPrice = Shopify.formatMoney(selectedVariant.price);
          regularPrice = regularPrice.replace('$', currentCurrency);          
          var discountPrice = Shopify.formatMoney(discountedPrice);
          discountPrice = discountPrice.replace('$', currentCurrency);

          // Split Variant Title

          var variantTitle = selectedVariant.title.split(" / ").pop();
          
          const productDetails = {
            prodId: selectedProduct.id,
            varId: selectedVariant.id,
            featureImage: selectedProduct.featured_image,
            price: regularPrice,
            variantTitle: variantTitle,
            discountedPrice: discountPrice,
            index: `${selectedVariant.id+'_'+ selectedProducts.length}`,
            selling_plan_groups:selectedProduct.selling_plan_groups,
            selling_plans: selectedVariantSellingPlans,
          };    
          // Create HTML structure for the product title
          const itemTitleHTML = `
            <li class="items-main" data-prod-id="${selectedProduct.id}" data-var-id="${selectedVariant.id}" data-index="${selectedVariant.id+'_'+ selectedProducts.length}">
              <div class="item-name">
                <div class="close-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 14 14" fill="none">
                    <circle cx="7" cy="7" r="6.5" transform="rotate(-180 7 7)" fill="#FAF4DE" stroke="#0D394E"/>
                    <path d="M5 9L7 7L5 5" stroke="#0D394E" stroke-linecap="round"/>
                    <path d="M9 5L7 7L9 9" stroke="#0D394E" stroke-linecap="round"/>
                  </svg>
                </div>
                <div class="item-title">
                  <h4>${selectedProduct.title} <span>${variantTitle}</span></h4>
                </div>
              </div>
              <div class="item-price">
                <h5 class="custom-js-price price"><span class="check-price regular-price custom-js-price price">${regularPrice}</span>${discountPrice}</h5>
              </div>
            </li>
          `;
    
          // Add the product title to the right side section
          $(".items-details-wrapper ul").append(itemTitleHTML);
          // $('.bundle-section-main .info_bg').show();    
          // Add product details to the selectedProducts array
          selectedProducts.push(productDetails);

          // ADD Regular total price 
            let totalPrice = 0, regular_price = 0;
            selectedProducts.forEach(product => {
              totalPrice += parseFloat(product.price.replace(/[^\d.-]/g, ''));
              regular_price += parseFloat(product.discountedPrice.replace(/[^\d.-]/g, ''));
            });
            
            $('.loop-discount-price').text(currentCurrency + totalPrice.toFixed(2));
            $('.loop-one-time-purchase-option-price-amount').text(currentCurrency + regular_price.toFixed(2));

            //ADD Discount Price
            var firstOptionDiscount = parseFloat($('.loop-selling-plan-selector').find('option:first').attr('data-discount'));
            if (!isNaN(firstOptionDiscount)) {
              var amount_get = parseFloat($('.loop-one-time-purchase-option-price-amount').text().replace(currentCurrency, ''));
              var discounted_Price = (amount_get - (amount_get * (firstOptionDiscount / 100))).toFixed(2);
              $('.loop-subscription-group-price-amount').text(currentCurrency + discounted_Price);
            }
            
            if (!isNaN(firstOptionDiscount)) {
              let discount_rate = 0;
                    selectedProducts.forEach(product => {
                      discount_rate += parseFloat(product.discountedPrice.replace(/[^\d.-]/g, ''));
                    });
              discount_rate = discount_rate.toFixed(2);
              $('.loop-selling-discount').text(currentCurrency + discount_rate);

              if(window.innerWidth > 1024){
                var isNoDiscount = parseFloat($('.product-single__form.desktop_only_widget .loop-selling-plan-selector').find('option:checked').attr('data-discount'))
              }else{
                var isNoDiscount = parseFloat($('.product-single__form.mobile_only_widget .loop-selling-plan-selector').find('option:checked').attr('data-discount'))
              }
              if(isNoDiscount == 0){
                $('.product-custom-bundle .info_bg .product-single__form .loop-subscription-group-discount-badge').text(`Save ${currentCurrency}0.00`)
              }else{
                var remainingPrice = discount_rate - discounted_Price;
                remainingPrice = remainingPrice.toFixed(2)
                $('.product-custom-bundle .info_bg .product-single__form .loop-subscription-group-discount-badge').text(`Save ${currentCurrency + remainingPrice }`)
              }
            }



          // Product Add Counts
          const productCount = $(".product-amount-wrapper .amount-items.active button").data('product-count');

          if(mainRemainingCount >= productCount){
            var variantSelector = $('.product-grid .grid__item .select__select'),
            AddButton = $('.card-item-add-btn-wrapper .add-btn');
            
            disabledElements(variantSelector,AddButton);
          }
          var remainingCounts = productCount - selectedProducts.length
          if($('.select-product-counts .select-remaining-counts')){
            $('.select-product-counts .select-remaining-counts').text(selectedProducts.length);
          }
          if($('.bundle-select-count .bundle-remaining-counts')){
            $('.bundle-select-count .bundle-remaining-counts').text(selectedProducts.length);
          }
          if($('.bundle-atc-btn .cart-remaining-count')){
            $('.bundle-atc-btn .cart-remaining-count').text(remainingCounts);
          }

          // Shop Product Description when Select
          // if($('.bundle_product_details')){
          //   $('.bundle_product_details .bundle_info_section[data-id="'+selectedProduct.id+'"]').removeClass('hide');
          //   $(`.fill-item`).each(function(ele){
          //     var id = $(this).attr('data-prod-id'), indx = $(this).index();
          //     $(`.bundle_product_details .bundle_info_section[data-id="${id}"]`).attr('data-index',indx);
          //   })
          // }
          if ($('.bundle_product_details').length) {
          $('.bundle_product_details .bundle_info_section[data-id="' + selectedProduct.id + '"]').removeClass('hide');
          
          $(`.fill-item`).each(function (ele) {
            var id = $(this).attr('data-prod-id');
            var indx = $(this).index();
        
            var $targetElement = $(`.bundle_product_details .bundle_info_section[data-id="${id}"]`);
            
            // Check if data-index is not already set
            if (!$targetElement.attr('data-index')) {
              $targetElement.attr('data-index', indx);
            }
          });
        }

        }
      }
    });

      $('body').on('change', '.loop-selling-plan-selector', function() {
        var selectdiscount = parseFloat($(this).find('option:selected').attr('data-discount'));
        if (!isNaN(selectdiscount)) {
            var get_val = parseFloat($('.loop-one-time-purchase-option-price-amount').text().replace(currentCurrency, ''));
            var discountedPrice = (get_val - (get_val * (selectdiscount / 100))).toFixed(2);
            $('.loop-subscription-group-price-amount').text(currentCurrency + discountedPrice);
          }
          if (!isNaN(selectdiscount)) {
            if(selectdiscount == 0){
              $('.loop-selling-discount').hide()
              $('.product-custom-bundle .info_bg .product-single__form .loop-subscription-group-discount-badge').text(`Save ${currentCurrency}0.00`)
            }else{
              $('.loop-selling-discount').show()
                let discount_rate = 0;
                      selectedProducts.forEach(product => {
                        discount_rate += parseFloat(product.discountedPrice.replace(/[^\d.-]/g, ''));
                      });
                discount_rate = discount_rate.toFixed(2);
                $('.loop-selling-discount').text(currentCurrency + discount_rate);
              
                if(window.innerWidth > 1024){
                  var isNoDiscount = parseFloat($('.product-single__form.desktop_only_widget .loop-selling-plan-selector').find('option:checked').attr('data-discount'))
                }else{
                  var isNoDiscount = parseFloat($('.product-single__form.mobile_only_widget .loop-selling-plan-selector').find('option:checked').attr('data-discount'))
                }
                if(isNoDiscount == 0){
                  $('.product-custom-bundle .info_bg .product-single__form .loop-subscription-group-discount-badge').text(`Save ${currentCurrency}0.00`)
                }else{
                  var remainingPrice = discount_rate - discountedPrice;
                  remainingPrice = remainingPrice.toFixed(2)
                  $('.product-custom-bundle .info_bg .product-single__form .loop-subscription-group-discount-badge').text(`Save ${currentCurrency + remainingPrice }`)
                }
              }

            }
        });


    // Close icon click event to remove product from list
    $('body').on('click', '.close-icon', function(evt) {
      var productElement = $(this).parent();
      if(productElement.hasClass('item-name')){
        productElement = productElement.parent();
      }
      const index = productElement.data('index');
      const prodId = productElement.data('prod-id');

      let sameEleCount = $('.items-media-wrapper li.fill-item[data-prod-id="'+prodId+'"]').length

      // Shop Product Description when Select
      if(sameEleCount === 1){
        if($('.bundle_product_details')){
          $('.bundle_product_details .bundle_info_section[data-id="'+prodId+'"]').addClass('hide');
        }
      }

      // Remove product from selectedProducts array
      selectedProducts = selectedProducts.filter(product => product.index !== index);
      let totalPrice = 0, regular_price = 0;
            selectedProducts.forEach(product => {
              totalPrice += parseFloat(product.price.replace(/[^\d.-]/g, ''));
              regular_price += parseFloat(product.discountedPrice.replace(/[^\d.-]/g, ''));
            });
            
            $('.loop-discount-price').text(currentCurrency + totalPrice.toFixed(2));
            $('.loop-one-time-purchase-option-price-amount').text(currentCurrency + regular_price.toFixed(2));

      var firstOptionDiscount = parseFloat($('.loop-selling-plan-selector').find('option:first').attr('data-discount'));
            if (!isNaN(firstOptionDiscount)) {
              var amount_get = parseFloat($('.loop-one-time-purchase-option-price-amount').text().replace(currentCurrency, ''));
              var discounted_Price = (amount_get - (amount_get * (firstOptionDiscount / 100))).toFixed(2);
              $('.loop-subscription-group-price-amount').text(currentCurrency + discounted_Price);
            }
            
            if (!isNaN(firstOptionDiscount)) {
               let discount_rate = 0;
                    selectedProducts.forEach(product => {
                      discount_rate += parseFloat(product.discountedPrice.replace(/[^\d.-]/g, ''));
                    });
              discount_rate = discount_rate.toFixed(2);
              $('.loop-selling-discount').text(currentCurrency + discount_rate);

               if(window.innerWidth > 1024){
                  var isNoDiscount = parseFloat($('.product-single__form.desktop_only_widget .loop-selling-plan-selector').find('option:checked').attr('data-discount'))
                }else{
                  var isNoDiscount = parseFloat($('.product-single__form.mobile_only_widget .loop-selling-plan-selector').find('option:checked').attr('data-discount'))
                }
                if(isNoDiscount == 0){
                  $('.product-custom-bundle .info_bg .product-single__form .loop-subscription-group-discount-badge').text(`Save ${currentCurrency}0.00`)
                }else{
                  var remainingPrice = discount_rate - discounted_Price;
                  remainingPrice = remainingPrice.toFixed(2)
                  $('.product-custom-bundle .info_bg .product-single__form .loop-subscription-group-discount-badge').text(`Save ${currentCurrency + remainingPrice }`)
                }
            }
      
      
      mainRemainingCount = selectedProducts.length
      
      // Remove corresponding media element
      var fillElement = $(".items-media-wrapper ul li.fill-item[data-index='"+index+"']")
      if(fillElement){
        fillElement.remove();
      }
      var itemElement = $(".items-details-wrapper .items-main[data-index='"+index+"']")
      if(itemElement){
        itemElement.remove();
      }

      // Remove the product element from the DOM
      productElement.remove();

      var removeChangeElement = $(".product-amount-wrapper .amount-items.active button");
      if(removeChangeElement){
        var title_handle = removeChangeElement.data('title-handle'),
        title = removeChangeElement.data('title'),
        product_count = removeChangeElement.data('product-count'),
        discount = removeChangeElement.data('discount'),
        discount_text = removeChangeElement.data('discount-text');
        changeProductAmountData(title_handle, title, product_count, discount, discount_text)
      }
      if(mainRemainingCount === 0){
        const cartButton = document.querySelector('.cart-btn-main.mobile_only .add-to-cart-button-wrapper');
        const bundleContainer = document.querySelector('.bundle-items-container');
        if (cartButton) {
          cartButton.classList.remove('sticky');
        }
        if (bundleContainer) {
          bundleContainer.classList.remove('sticky');
        }
      }
    });

    // Add all Products in Cart
    $('body').on('click','.cart-btn-main .bundle-atc-btn:not(disabled)', function(evt){
      const $this = $(this);

      const productMap = {};
      var hasSubscription = isMobile ? $('input[name="mobile-view-1-loop_purchase_option"]:checked').attr('data-name'): $('.desktop_only_widget input[name="desktop-view-1-loop_purchase_option"]:checked').attr('data-name'),
        selectFreqVal = isMobile ? $('select.loop-selling-plan-selector:eq(0) option:selected').text() : $('.desktop_only_widget select.loop-selling-plan-selector:eq(0) option:selected').text();
      // console.log('hasSubscription',hasSubscription)
      var isSubs = hasSubscription.indexOf('one-time-purchase') > -1? false:true;
      selectedProducts.forEach(product => {

        /*
        * Main product selling plan has priority.
        * If main product does not have a matching selling plan,
        * ALL selling plan groups of the selected bundle product are searched.
        * A matched plan is only used when it is allocated to the variant.
        */
        const selling_planId = getBundleSellingPlan(
          product,
          selectFreqVal,
          isSubs
        );

        const uniqueKey = `${product.prodId}_${product.varId}`;

        if (productMap[uniqueKey]) {
          productMap[uniqueKey].quantity += 1;
        } else {
          productMap[uniqueKey] = {
            ...product,
            selling_plan: selling_planId,
            quantity: 1
          };
        }
      });     

      // console.log('productMap',productMap)

      $this.addClass('loading');

      let discountPercentage = Number($(".product-amount-wrapper .amount-items.active button").data('discount'));

      // const remainingPercentage = (100 - discountPercentage) / 100;
      
      const cartArray = Object.values(productMap);      
      // console.log("discountPercentage",typeof discountPercentage);
      
      const formData = {
        'items': cartArray.map(item => ({
          'id': item.varId,      // Variant ID
          'quantity': item.quantity,  // Quantity
          'selling_plan':item.selling_plan, //Selling plan id if subscription selected
          'properties': {
            '_bundle_discount': discountPercentage,
            '_custom_bundle_id': `bundle-id-${Date.now()}`,
          }
        }))
      };

      // console.log("formData",formData)
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('Failed to add items to cart');
        }
      })
      .then(data => {
        console.log('Successfully added to cart:', data);
        // selectedProducts = [];
        // $('.items-details-wrapper ul li .item-name .close-icon').each(function() {
        //   $(this).trigger('click');
        // });
        $this.removeClass('loading');
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    });


    if (window.innerWidth < 1024) {
      const cartButton = document.querySelector('.cart-btn-main.mobile_only .add-to-cart-button-wrapper');
      const bundleContainer = document.querySelector('.bundle-items-container');
      const bundleWrapper = document.querySelector('.custom-bundle-main .bundle-grid-wrapper');
    
      // Store the original top position of elements
      const cartButtonOriginalTop = cartButton?.offsetTop - 500 || 0;
      const bundleContainerOriginalTop = bundleContainer?.offsetTop || 0;
    
      const handleScroll = () => {
        // console.log("selectedProducts",selectedProducts)
        if(selectedProducts.length > 0){
          const scrollY = window.scrollY || document.documentElement.scrollTop;
      
          // console.log("SCROLL",cartButtonOriginalTop,bundleContainerOriginalTop,scrollY,selectedProducts)
          // Handle cart button stickiness
          if (cartButton) {
            if (scrollY < cartButtonOriginalTop) {
              cartButton.classList.add('sticky');
            } else {
              cartButton.classList.remove('sticky');
            }
          }
      
          // Handle bundle container stickiness
          if (bundleContainer) {
            if (scrollY > bundleContainerOriginalTop) {
              bundleWrapper.classList.add('sticky');
              bundleContainer.classList.add('sticky');
            } else {
              bundleWrapper.classList.remove('sticky');
              bundleContainer.classList.remove('sticky');
            }
          }
        }else{
          if (cartButton) {
            cartButton.classList.remove('sticky');
          }
          if (bundleContainer) {
            bundleWrapper.classList.remove('sticky');
            bundleContainer.classList.remove('sticky');
          }
        }
      };      
      window.addEventListener('scroll', handleScroll);
    }
  }  
})